module.exports = "https://cdn2-fs.clearscore.com/flux/images/6035cd0289493bd669e3b4ad35260422.jpg";